<template>
  <div class="bg-white rounded-lg p-8">
    <Loader v-if="loading"/>
    <div v-else>
      <div class="flex justify-end">
        <button @click="resetDefault"
                class="mb-5 pl-2 pr-3 py-2 font-medium bg-blue-700 hover:bg-blue-800 text-white rounded-lg flex justify-center items-center"
        >
          <RefreshIcon class="w-5 h-5 inline mr-2 flex-shrink-0"/>
          {{ $lang.app.RESET_DEFAULT_SETTINGS }}
        </button>
      </div>
      <table class="table-auto w-full mb-8">
        <thead class="border-solid border">
        <tr>
          <th class="py-3 px-5 border border-slate-300">{{ $lang.app.STATUS }}</th>
          <th class="py-3 px-5 border border-slate-300">{{ $lang.app.ROLES }}</th>
          <th class="py-3 px-5 border border-slate-300">{{ $lang.app.ACTION }}</th>
          <th class="py-3 px-5 border border-slate-300">{{ $lang.app.NEXT_STATUS }}</th>
          <th class="w-2.5 py-3 px-5 border border-slate-300"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in applicationRoutes" :key="index">
          <td class="py-3 px-5 border border-slate-300">
            <div v-if="isEditItem(item)">
              <Multiselect
                  v-model="editItem.currentStatus"
                  :options="helper.statuses"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
              >
              </Multiselect>
            </div>
            <div v-else>
              {{ $lang.$translate({ru: item.currentStatus.nameRu, kg: item.currentStatus.nameKg }) }}
            </div>
          </td>
          <td class="max-w-xs py-3 px-5 border border-slate-300">
            <div v-if="isEditItem(item)">
              <Multiselect
                  mode="tags"
                  v-model="editItem.roles"
                  :options="helper.roles"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
              >
              </Multiselect>
            </div>
            <div v-else>
              {{ getRoles(item.roles) }}
            </div>
          </td>
          <td class="py-3 px-5 border border-slate-300">
            <div v-if="isEditItem(item)">
              <Multiselect
                  v-model="editItem.actions"
                  :options="helper.actions"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
              >
                <template v-slot:option="{ option }">
                  <div>
                    <div>{{ option.label }}</div>
                    <div class="text-xs" :title="option.constName">{{ option.constName }}</div>
                  </div>
                </template>
              </Multiselect>
            </div>
            <div v-else :title="item.actions.constName">
              <div>{{ $lang.$translate({ru: item.actions.nameRu, kg: item.actions.nameKg }) }}</div>
              <div class="max-w-xs text-xs truncate">{{ item.actions.constName }}</div>
            </div>
          </td>
          <td class="py-3 px-5 border border-slate-300">
            <div v-if="isEditItem(item)">
              <Multiselect
                  v-model="editItem.nextStatus"
                  :options="helper.statuses"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
              >
              </Multiselect>
            </div>
            <div v-else>
              {{ $lang.$translate({ru: item.nextStatus.nameRu, kg: item.nextStatus.nameKg }) }}
            </div>
          </td>
          <td class="py-3 px-5 table-center border border-slate-300">
            <div v-if="isEditItem(item)" class="flex justify-center">
              <button class="mx-1" @click="update(editItem)">
                <SaveIcon class="w-6 h-6 text-green-500"/>
              </button>
              <button class="mx-1" @click="resetEditItem">
                <ArrowCircleLeftIcon class="w-6 h-6 text-gray-500"/>
              </button>
            </div>
            <div v-else class="flex justify-center">
              <button class="mx-1" @click="setEditItem(item)">
                <PencilAltIcon class="w-6 h-6 text-blue-500"/>
              </button>
              <button class="mx-1" @click="deleteItem(item)">
                <TrashIcon class="w-6 h-6 text-red-500"/>
              </button>
            </div>
          </td>
        </tr>
        <tr v-if="createItem">
          <td class="py-3 px-5 border border-slate-300">
            <div>
              <Multiselect
                  v-model="createItem.currentStatus"
                  :options="helper.statuses"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
              >
              </Multiselect>
            </div>
          </td>
          <td class="max-w-xs py-3 px-5 border border-slate-300">
            <div>
              <Multiselect
                  mode="tags"
                  v-model="createItem.roles"
                  :options="helper.roles"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
              >
              </Multiselect>
            </div>
          </td>
          <td class="py-3 px-5 border border-slate-300">
            <div>
              <Multiselect
                  v-model="createItem.actions"
                  :options="helper.actions"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
              >
                <template v-slot:option="{ option }">
                  <div>
                    <div>{{ option.label }}</div>
                    <div class="text-xs" :title="option.constName">{{ option.constName }}</div>
                  </div>
                </template>
              </Multiselect>
            </div>
          </td>
          <td class="py-3 px-5 border border-slate-300">
            <div>
              <Multiselect
                  v-model="createItem.nextStatus"
                  :options="helper.statuses"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
              >
              </Multiselect>
            </div>
          </td>
          <td class="py-3 px-5 table-center border border-slate-300">
            <div class="flex justify-center">
              <button class="mx-1" @click="store(createItem)">
                <SaveIcon class="w-6 h-6 text-green-500"/>
              </button>
              <button class="mx-1" @click="resetCreateItem">
                <XIcon class="w-6 h-6 text-red-500"/>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="flex justify-end">
        <button v-if="!createItem" @click="setCreateItem"
            class="mb-5 pl-2 pr-3 py-2 font-medium bg-blue-700 hover:bg-blue-800 text-white rounded-lg flex justify-center items-center"
        >
          <PlusIcon class="w-5 h-5 inline mr-2 flex-shrink-0"/>
          {{ $lang.app.ADD }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import applicationRouteApi from "../../../api/admin/applicationRoute";
import {all as rolesAll} from "../../../helpers/constants/roles";

export default {
  data() {
    return {
      loading: false,
      applicationRoutes: [],
      editItem: null,
      createItem: null,
      helper: {
        statuses: [],
        actions: [],
        roles: [],
      }
    };
  },
  created() {
    this.initStatuses()
    this.initActions()
    this.initRoles()
    this.fetchResources()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$emitter.emit('closeSidebar')
    })
  },
  methods: {
    rolesAll,
    initStatuses() {
      applicationRouteApi
          .statuses()
          .then(res => {
            this.helper.statuses = res.map(item => ({
              value: item.id,
              label: this.$lang.$translate({ru: item.nameRu, kg: item.nameKg})
            }))
          })
    },
    initActions() {
      applicationRouteApi
          .actions()
          .then(res => {
            this.helper.actions = res.map(item => ({
              value: item.id,
              label: this.$lang.$translate({ru: item.nameRu, kg: item.nameKg}),
              description: item.description,
              constName: item.constName,
            }))
          })
    },
    initRoles() {
      this.helper.roles = rolesAll().map(item => ({
        value: item.key,
        label: this.$lang.app[item.labelRef],
      }))
    },
    fetchResources() {
      this.loading = true
      applicationRouteApi
          .list()
          .then(res => {
            this.applicationRoutes = res;
          })
          .finally(() => {
            this.loading = false
          });
    },
    isEditItem(item) {
      return this.editItem && this.editItem.id === item.id
    },
    getRoles(roles) {
      return rolesAll().filter(item => roles.includes(item.key)).map(item => this.$lang.app[item.labelRef]).join(', ')
    },
    setEditItem(item) {
      this.editItem = {
        id: item.id,
        currentStatus: item.currentStatus.id,
        actions: item.actions.id,
        nextStatus: item.nextStatus.id,
        roles: item.roles,
      }
    },
    resetEditItem() {
      this.editItem = null
    },
    update(form) {
      applicationRouteApi.update(form.id, {
        currentStatus: form.currentStatus,
        actions: form.actions,
        nextStatus: form.nextStatus,
        roles: form.roles,
      }).then(res => {
        this.applicationRoutes[this.applicationRoutes.findIndex(item => item.id === form.id)] = res
        this.editItem = null
        this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
      }).catch(error => {
        if(error.response.status == 422) {
          this.$snotify.error(error.response.data.message)
        } else {
          this.$snotify.error(error.response.statusText)
        }
      });
    },
    deleteItem(item) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationRouteApi
              .destroy(item.id)
              .then(() => {
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
                this.fetchResources()
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    },
    setCreateItem() {
      this.createItem = {
        currentStatus: null,
        actions: null,
        nextStatus: null,
        roles: [],
      }
    },
    resetCreateItem() {
      this.createItem = null
    },
    store(form) {
      applicationRouteApi
          .store(form)
          .then(() => {
            this.createItem = null
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
            this.fetchResources()
          })
          .catch(error => {
            if(error.response.status == 422) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(error.response.statusText)
            }
          });
    },
    resetDefault() {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_RESET_DEFAULT_SETTINGS,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationRouteApi
              .resetDefault()
              .then(() => {
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
                this.fetchResources()
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    },
  },
};
</script>
